
// @ts-ignore
export const isMetamaskAvailable = typeof window.ethereum !== 'undefined';

// @ts-ignore
export const ethereum = window.ethereum;